<template>
    <div class="container-fluid p_top_header projects">
        <div class="top_title">
            <div class="animation_text m_r_10">
                {{{ $t('sections.projects.title') }}}
            </div>
            <ul class="list_projetos">
                <li><a href="#" :class="{ 'active': filter == '' }" @click.prevent="filter = ''">{{ $t('all') }}</a></li>
                <li><a href="#" :class="{ 'active': filter == 'system' }" @click.prevent="filter = 'system'">{{ $t('systems') }}</a></li>
                <li><a href="#" :class="{ 'active': filter == 'site' }" @click.prevent="filter = 'site'">{{ $t('sites') }}</a></li>
                <li><a href="#" :class="{ 'active': filter == 'app' }" @click.prevent="filter = 'app'">{{ $t('apps') }}</a></li>
                <li><a href="#" :class="{ 'active': filter == 'ecommerce' }" @click.prevent="filter = 'ecommerce'">{{ $t('ecommerces') }}</a></li>
            </ul>
        </div>
        <div class="row">
            <!-- | filterBy filter in 'tags'-->
            <div class="box col-xs-12 col-sm-6 col-md-4 col-lg-3" @click="toggleClass($event)" v-for="project in records.projects | filterBy filter 'tags'" transition="projects-trans">
                <div class="content_table">
                    <div class="bg_projects" :class="project.background"></div>
                    <div class="d_table_cell relative z_9">
                        <h3 class="t_center title_projects">{{ project.name }}</h3>
                        <span class="job">{{ $t(project.job) }}</span>
                    </div>
                    <div class="detail_hover">
                        <div class="d_table_cell">
                            <h4>{{ project.name }}</h4>
                            <span v-if="project.description">{{ project.description[getLang] }}</span>
                            <a :href="'http://' + project.link" target="_blank">{{ project.link }}</a>
                            <small class="c_white show">{{ project.year }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery'
    import { getLang } from '../vuex/settings/getters'
    import Vue from 'vue'
    import VueAnimatedList from 'vue-animated-list'

    Vue.use(VueAnimatedList)

    export default {
        name: 'Projects',
        data () {
            return {
                records: require('../data/projects.json'),
                filter: '',
                meta: {
                    title: 'Projetos',
                    description: 'Conheça os projetos desenvolvidos pela Guco',
                    pageUrl: 'http://www.guco.com.br/projetos',
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'description' : this.meta.description,
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                    },
                    // Facebook / Open Graph
                    property: {
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                    }
                }
            },
            link () {
                return {
                    canonical: {
                        href: this.meta.pageUrl
                    },
                }
            }
        },
        vuex: {
            getters: {
                getLang
            }
        },
        methods: {
            toggleClass (e) {
                jQuery(e.target).parents('.box').toggleClass('active');
            }
        }
    }
</script>

<style scoped>
    .projects-trans-transition {
        transition: all .5s ease;
    }
    .projects-trans-enter,
    .projects-trans-leave {
        z-index: -1;
        opacity: 0;
        position: absolute; /* important for removal move to work */
    }
    .projects-trans-move {
        transition: transform .5s cubic-bezier(.55,0,.1,1); /* applied when moving */
    }
</style>



// WEBPACK FOOTER //
// Projects.vue?4f4347c8